import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'react-bootstrap'
import CreatableSelect from 'react-select/creatable'
import { useT } from '@transifex/react'

import useForm from '../../hooks/useForm'
import { swalError } from '../../common/components/Swaler'
import { createEntity, createStorage } from '../../common/redux/collectionActions'

const CreateStorage = ({ history }) => {
  const t = useT()
  const dispatch = useDispatch()
  const companies = useSelector((state) => state.collectionData.companies.companies?.sort((a, b) => (a.name > b.name ? 1 : -1)) || [])
  const admin = useSelector((state) => state.collectionData.admin)

  const [formValues, onFormChange] = useForm({ name: '', qlocxid: '', qlocxids: [], companyId: null })

  const onQlocxidsChange = (field) => {
    const qlocxids = field ? field.map((item) => item.value) : []
    onFormChange({ target: { name: 'qlocxids', value: qlocxids } })
  }

  const formatCreateLabel = (inputValue) => t('Create/Add {inputValue}', { inputValue })

  const createCompany = (name) => dispatch(createEntity('company', { name: name.trim() })).then((r) => onFormChange({ target: { name: 'companyId', value: r.data.find((c) => c.name === name)._id } }))
  const submit = (companyName) =>
    createStorage({ ...formValues, companyName })
      .then((r) => {
        dispatch({ type: 'CREATE_LOCK_SUCCESS', payload: { _id: r.data.lockId, storage: r.data.storageId, custom_name: formValues.name, address: {}, type: 'passage', users: [] } })
        history.push(`/storage/${r.data.storageId}?iframeRoute=storageSettings`)
      })
      .catch((e) => {
        if (e.isAxiosError) swalError(e.response.data.message)
        else swalError(e.message)
      })

  const company = useMemo(() => {
    if ((companies || []).length === 0 || !formValues.companyId) return null

    return { label: companies.find((c) => c._id === formValues.companyId)?.name, value: formValues.companyId }
  }, [companies, formValues.companyId])

  return (
    <div>
      <h1>{t('New Smart Storage')}</h1>
      <div>
        <input type="text" style={{ padding: 8, width: '30%', border: '1px solid lightgrey', borderRadius: 3 }} placeholder={t('Project name *')} name="name" onChange={onFormChange} value={formValues.name} />
        <br />
        <br />
        <input type="text" style={{ padding: 8, width: '30%', border: '1px solid lightgrey', borderRadius: 3 }} placeholder={t('Qlocx controller ID. Leave empty if non-existent')} name="qlocxid" onChange={onFormChange} value={formValues.qlocxid} />
        <br />
        <br />

        {admin?.user?.roles?.includes('dataanalytics') && (
          <div style={{ width: '30%' }}>
            <CreatableSelect noOptionsMessage={() => t('Empty')} isMulti isClearable name="qlocxids" formatCreateLabel={formatCreateLabel} onChange={onQlocxidsChange} placeholder={t('Add multiple controllers to storage')} />
            <br />
          </div>
        )}

        <div style={{ width: '30%' }}>
          <CreatableSelect
            value={company}
            isClearable
            onCreateOption={createCompany}
            formatCreateLabel={formatCreateLabel}
            onChange={(field) => onFormChange({ target: { name: 'companyId', value: field?.value } })}
            options={companies.map((c) => ({ label: c.name, value: c._id }))}
            placeholder={t('Client company')}
          />
        </div>
        <br />
        <br />
        <Button onClick={() => submit(company.label)}>{t('Create')}</Button>
      </div>
    </div>
  )
}

export default CreateStorage
